export default __webpack_public_path__ + "static/media/SaveNote.07fe9867.svg";